import { h } from 'preact'
import style from './index.scss'

const Container = ({children, class: mixin}) => (
  <div class={style.container + (mixin ? ` ${mixin}` : '')}>
    {children}
  </div>
)

export default Container



// WEBPACK FOOTER //
// ./components/Container/index.js